
export default {
    setUsergroups (state, usergroups) {
        state.usergroups = usergroups
    },
}
